import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Firebase configuration for taskDojo app
const firebaseConfig = {
  apiKey: "AIzaSyAcRYiuKGBeQqMZJJdYWRgtATA-9bTW0-0",
  authDomain: "taskdojo-dev.firebaseapp.com",
  projectId: "taskdojo-dev",
  storageBucket: "taskdojo-dev.firebasestorage.app",
  messagingSenderId: "231035309015",
  appId: "1:231035309015:web:11241910f4ad37c61ed992",
  measurementId: "G-S1KR27TQTM"
};

// Initialize Firebase with error handling
let app: FirebaseApp;
try {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApp();
  }
} catch (error) {
  console.error('Failed to initialize Firebase app:', error);
  throw error;
}

// Initialize services
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const db = getFirestore(app);
export { app };